// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"f3c09e1c","189":"9429341f","232":"1674417f","978":"d019849f"}[chunkId] + ".chunk.js";
};